import "@fortawesome/fontawesome-free";
import simulate from "../../modules/simulate";
import mask from '../jquery.mask';

$("#tel").mask("(00) 00000-0000");
simulate();
// lightbox

const lightboxVideo = GLightbox({
    selector: '.glightbox'
});

lightboxVideo.on('slide_changed', ({ prev, current }) => {
    console.log('Prev slide', prev);
    console.log('Current slide', current);

    const { player } = current;

    if (player) {
        player.on('play', (event) => {
            console.log('Started play');
        });

        player.on('volumechange', (event) => {
            console.log('Volume change');
        });

        player.on('ended', (event) => {
            console.log('Video ended');
        });
    }
});

// video effect

const previewImg = document.querySelector('#preview');

previewImg.addEventListener('mouseenter', () => {
    previewImg.setAttribute('src', 'site/img/CalculadoraSolar/video/video-preview.webp');
})

previewImg.addEventListener('mouseleave', () => {
    previewImg.setAttribute('src', 'site/img/CalculadoraSolar/video/thumb-nail.png');
})

// responsividade

addEventListener('DOMContentLoaded', function(){
    changeToSlider()
    formImgPosition()
});
addEventListener('resize', function(){
    changeToSlider()
    formImgPosition()
});

let screen = window.screen;

function changeToSlider() {
    const cards_vantagens = document.querySelector('#cards-vantagens'),
          cards_beneficios = document.querySelector('#cards-beneficios'),
          swiper_vantagens = document.querySelector('#swiper-vantagens'),
          swiper_beneficios = document.querySelector('#swiper-beneficios');
    
    if ( screen.availWidth <= 1018 ) {
        cards_vantagens.classList.add('hidden');
        swiper_vantagens.classList.remove('hidden')
    } else {
        cards_vantagens.classList.remove('hidden');
        swiper_vantagens.classList.add('hidden')
    }

    if ( screen.availWidth <= 1264 ) {
        cards_beneficios.classList.add('hidden');
        swiper_beneficios.classList.remove('hidden')
    } else {
        cards_beneficios.classList.remove('hidden');
        swiper_beneficios.classList.add('hidden')
    }
}

function formImgPosition() {
    const formImg = document.querySelector('#form-img');

    if ( screen.availWidth <= 991 ) {
        formImg.classList.add('absolute');
    } else {
        formImg.classList.remove('absolute');
    }
}